import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 70vh;
  padding: 2rem;
`;

const Title = styled.h1`
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: #333;
`;

const Description = styled.p`
  font-size: 1.2rem;
  margin-bottom: 2rem;
  max-width: 600px;
  color: #666;
`;

const ErrorDetails = styled.div`
  background-color: #f8f8f8;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 2rem;
  max-width: 700px;
  overflow-x: auto;
  text-align: left;
  border: 1px solid #ddd;
`;

const StyledLink = styled(Link)`
  padding: 0.75rem 1.5rem;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  font-weight: 600;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #0056b3;
    transform: translateY(-3px);
    box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  }
`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <ErrorContainer>
          <Title>Something Went Wrong</Title>
          <Description>
            We're sorry, but there was an error loading this page. Please try refreshing or return to the home page.
          </Description>
          {process.env.NODE_ENV === 'development' && this.state.error && (
            <ErrorDetails>
              <h3>Error Details (Development Mode Only):</h3>
              <p>{this.state.error.toString()}</p>
              <p>Component Stack:</p>
              <pre>{this.state.errorInfo?.componentStack}</pre>
            </ErrorDetails>
          )}
          <StyledLink to="/">
            Return to Home
          </StyledLink>
        </ErrorContainer>
      );
    }

    return this.props.children; 
  }
}

export default ErrorBoundary; 